import ProjectAttributesConfig from './ProjectAttributesConfig'

export default ProjectAttributesConfig
